import React from "react"
import { IFooter } from "../../../gatsby-graphql"
import {
  FooterInner,
  FooterWrapper,
  LinksWrapper,
  Legal,
  Links,
  Logos,
  LogoWrapper,
  Social,
  SocialIcon,
  StyledLink,
  SocialWrapper,
  LocalesSocialWrapper
} from "./footer-elements"
import { LogoImgStyle, LogoStyle } from "./footer-styles"
import { Link } from "gatsby"
import spritesheet from "../../assets/spritesheet.png"
import { GatsbyImage } from "gatsby-plugin-image"
import { ILocaleLink } from "../top-bar/common/Locales"

interface FooterProps {
  data?: IFooter
  locales?: ILocaleLink[]
  locale?: string
}

const Footer = ({ data, locales = [], locale}: FooterProps) => {
  if (!data) {
    return null
  }

  return (
    <FooterWrapper>
      <FooterInner>
        <SocialWrapper>
          <Logos>
            {data.logos?.map(
              (logo, index) =>
                logo?.image?.localFile?.childImageSharp && (
                  <LogoWrapper to={logo?.link?.url || ""} key={index}>
                    <GatsbyImage
                      image={
                        logo?.image?.localFile?.childImageSharp.gatsbyImageData
                      }
                      alt={logo?.alt || ""}
                      imgStyle={LogoImgStyle}
                      style={LogoStyle}
                    />
                  </LogoWrapper>
                )
            )}
          </Logos>
          <LocalesSocialWrapper>
            <Social>
              {data.socialMedia?.map((social, index) => (
                <Link to={social?.url || ""} key={index} hrefLang={locale}>
                  <SocialIcon
                    service={social?.service || ""}
                    spritesheet={spritesheet}
                  />
                </Link>
              ))}
            </Social>
          </LocalesSocialWrapper>
        </SocialWrapper>
        <LinksWrapper>
          <Links>
            {data.links?.map((link, index) => (
              <StyledLink to={link?.link?.url || ""} key={index} hrefLang={locale}>
                {link?.name}
              </StyledLink>
            ))}
          </Links>
          <Legal>{data.copyright}</Legal>
        </LinksWrapper>
      </FooterInner>
    </FooterWrapper>
  )
}

export default Footer
